import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../react-core/Flux/BaseStore";
import { BackOfficeProviderBulkValuationReport } from "../../../../../Wrap/Models/Models/BackOfficeIntegration/BackOfficeProviderBulkValuationReport";
import { BackOfficeProviderBulkValuationReportDispatcher, FluxResponse } from "./Variable";
export class BackOfficeProviderBulkValuationReportStoreState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: BackOfficeProviderBulkValuationReport[];
}

export class BackOfficeProviderBulkValuationReportStoreStatic extends BaseStore<
    BackOfficeProviderBulkValuationReportStoreState
> {
    constructor() {
        super();
        this.subscribeToDispatcher(BackOfficeProviderBulkValuationReportDispatcher, (actionData) =>
            this.onBackOfficeProvidersStoreResponse(actionData)
        );
    }
    onBackOfficeProvidersStoreResponse(actionData: FluxResponse): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
    public isLoading(): boolean {
        return this.getState().isLoading;
    }
    protected getDefaultState(): BackOfficeProviderBulkValuationReportStoreState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }
    public getData() {
        return this.getState().data;
    }
}
